module.exports = __webpack_public_path__ + "img/blackHardware.78933366.png";